// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__2aSsU","fullSize":"Menu_fullSize__1LW1u","menuTreeHeader":"Menu_menuTreeHeader__3pLx7","eye":"Menu_eye__dt3_0"};